import { Expose, Type } from 'class-transformer';

export class RescheduleHistoryModel {
  id: string;
  number: string;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'reschedule_on' })
  @Type(() => Date)
  rescheduleOn: Date | null;

  @Type(() => Number)
  price: number;
}

export class getRescheduleHistoryInput {
  saleId: string;
  type: 'flight' | 'cruise' | 'activity' | 'hotel';
}
